module.exports = __webpack_public_path__ + "img/advantage-item-06.889d39f2.png";